// Read colour/size metadata for the entire collection, including later product pages.
// Existing checkbox values and product filtering continue to use the theme's card tokens.
document.addEventListener("DOMContentLoaded", function () {
    const sidebar = document.querySelector("[data-filter-sidebar][data-filter-collection-url]");
    if (!sidebar || !sidebar.dataset.filterCollectionUrl) return;
    const containers = {
        color: sidebar.querySelector('[data-collection-filter-options="color"]'),
        size: sidebar.querySelector('[data-collection-filter-options="size"]')
    };
    if (!containers.color || !containers.size) return;

    let loading = false;
    let loaded = false;
    let status;

    function showStatus(message, retry) {
        if (!status) {
            status = document.createElement("p");
            status.setAttribute("role", "status");
            status.setAttribute("aria-live", "polite");
            const header = sidebar.querySelector(".filter-header");
            if (header) header.insertAdjacentElement("afterend", status);
            else sidebar.prepend(status);
        }
        status.replaceChildren(document.createTextNode(message));
        if (retry) {
            const button = document.createElement("button");
            button.type = "button";
            button.textContent = "Retry";
            button.addEventListener("click", load);
            status.append(document.createTextNode(" "), button);
        }
    }

    function readProductOptions(doc, options) {
        doc.querySelectorAll("[data-collection-filter-product]").forEach(function (product) {
            const id = product.dataset.collectionFilterProduct;
            if (!id) return;
            product.querySelectorAll("[data-filter-kind]").forEach(function (value) {
                const kind = value.dataset.filterKind;
                const name = value.dataset.filterName;
                const key = value.dataset.filterKey;
                if (!options[kind] || !name || !key) return;
                // Keep distinct supplier names; do not merge different colours by hex.
                const identity = JSON.stringify([key, name.trim()]);
                if (!options[kind].has(identity)) {
                    options[kind].set(identity, { name: name, key: key, hex: value.dataset.filterHex || "", products: new Set() });
                }
                const option = options[kind].get(identity);
                option.products.add(id);
                if (!option.hex && value.dataset.filterHex) option.hex = value.dataset.filterHex;
            });
        });
    }

    function updateOptions(kind, options) {
        const container = containers[kind];
        const remaining = new Map(options);
        // Reuse existing labels and inputs so checked state, ordering and existing colours survive.
        container.querySelectorAll("[data-filter-input]").forEach(function (input) {
            const label = input.closest("label");
            const text = label && label.querySelector("span");
            if (!text) return;
            const name = text.textContent.replace(/\s*\(\d+\)\s*$/, "").trim();
            const identity = JSON.stringify([input.value, name]);
            const option = remaining.get(identity);
            if (!option) return;
            const chip = text.querySelector("i");
            const children = [];
            if (chip) children.push(chip);
            children.push(document.createTextNode(option.name + " (" + option.products.size + ")"));
            text.replaceChildren.apply(text, children);
            remaining.delete(identity);
        });
        remaining.forEach(function (option) {
            const label = document.createElement("label");
            label.className = "filter-option";
            const text = document.createElement("span");
            if (kind === "color") {
                const chip = document.createElement("i");
                chip.style.backgroundColor = option.hex || "transparent";
                if (/^#fff(?:fff)?$/i.test(option.hex)) chip.style.border = "1px solid #ddd";
                text.appendChild(chip);
            }
            text.appendChild(document.createTextNode(option.name + " (" + option.products.size + ")"));
            const input = document.createElement("input");
            input.type = "checkbox";
            input.value = option.key;
            input.setAttribute("data-filter-input", "");
            input.dataset.filterType = kind;
            label.append(text, input);
            container.appendChild(label);
        });
    }

    async function readPage(url) {
        const controller = new AbortController();
        const timeout = window.setTimeout(function () { controller.abort(); }, 30000);
        try {
            const response = await fetch(url.href, { signal: controller.signal });
            if (!response.ok) throw new Error("Unable to load filter options");
            const doc = new DOMParser().parseFromString(await response.text(), "text/html");
            if (!doc.querySelector("[data-collection-filter-data]")) throw new Error("Invalid filter options response");
            return doc;
        } finally {
            window.clearTimeout(timeout);
        }
    }

    async function load() {
        if (loading || loaded) return;
        loading = true;
        showStatus("Loading more filters…", false);
        const options = { color: new Map(), size: new Map() };
        try {
            const base = new URL(sidebar.dataset.filterCollectionUrl, window.location.origin);
            if (base.origin !== window.location.origin) throw new Error("Invalid collection URL");
            base.search = "";
            base.searchParams.set("view", "filter-data");
            let next = base;
            const visited = new Set();
            while (next) {
                if (visited.has(next.href)) throw new Error("Repeated filter page");
                visited.add(next.href);
                const doc = await readPage(next);
                readProductOptions(doc, options);
                const link = doc.querySelector(".js-product-load-more");
                if (link) {
                    const href = link.dataset.nextUrl || link.getAttribute("href");
                    if (!href) throw new Error("Missing filter page URL");
                    const url = new URL(href, base);
                    if (url.origin !== base.origin || url.pathname !== base.pathname) throw new Error("Invalid filter page URL");
                    url.searchParams.set("view", "filter-data");
                    next = url;
                } else next = null;
            }
            // Commit only when every page succeeds; incomplete data never replaces current filters.
            updateOptions("color", options.color);
            updateOptions("size", options.size);
            loaded = true;
            if (status) status.remove();
        } catch (error) {
            showStatus("Some filter options couldn't load.", true);
        } finally {
            loading = false;
        }
    }

    sidebar.addEventListener("show.bs.offcanvas", load);
    if ("requestIdleCallback" in window) window.requestIdleCallback(load, { timeout: 3000 });
    else window.setTimeout(load, 1200);
});
